import { createApi } from '@reduxjs/toolkit/query/react';

import baseQueryWithOptions from './baseQueryWithOptions';
import { CacheTag } from '../CacheTag';

export const baseCacheTimeInSeconds = 30;

const api = createApi({
  baseQuery: baseQueryWithOptions,
  endpoints: () => ({}),
  keepUnusedDataFor:
    process?.env?.NODE_ENV === 'test' ? 0 : baseCacheTimeInSeconds,
  tagTypes: Object.keys(CacheTag),
});

export default api;
